import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Modal from "react-awesome-modal";
import Api from "../../Hooks/Api";
import useValidateRole from "../../Hooks/useValidateRole";

const Smtp = () => {
  const [open, setOpen] = useState(false);
  const [view, setView] = useState(false);

  const [inputs, setInputs] = useState({
    host: "",
    port: "",
    username: "",
    password: "",
    from: "",
  });

  const PageRole = "Smtp";

  const fetchData = async () => {
    try {
      const response = await Api.get("api/applicationSettings/getSmtpDetails");

      if (response.data) {
        setInputs(response.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleOpenModal = () => {
    setOpen(true);
    setView(false);
  };

  const handleView = () => {
    setOpen(true);
    setView(true);
  };

  const handleCloseModal = () => {
    setOpen(false);
    setView(false);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setInputs((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await Api.put("api/applicationSettings/updateSmtpDetails", inputs);

      alert("SMTP Details Updated Successfully");

      handleCloseModal();

      fetchData();
    } catch (error) {
      console.log(error);
      alert("Failed To Update SMTP Details");
    }
  };

  return (
    <div id="content" className="content">
      <ol className="breadcrumb float-xl-right">
        <li className="breadcrumb-item">
          <Link to="/">Home</Link>
        </li>

        <li className="breadcrumb-item active">SMTP Settings</li>
      </ol>

      <h1 className="page-header mb-3">SMTP Settings</h1>

      <div
        style={{
          backgroundColor: "#fff",
          padding: 20,
          borderRadius: 5,
        }}
      >
        <div className="d-flex mb-3">
          {useValidateRole(PageRole, "View") && (
            <button className="btn btn-info me-2" onClick={handleView}>
              View
            </button>
          )}

          {useValidateRole(PageRole, "Edit") && (
            <button className="btn btn-success" onClick={handleOpenModal}>
              Edit SMTP
            </button>
          )}
        </div>

        <table className="table table-bordered">
          <tbody>
            <tr>
              <td width="30%">
                <strong>Host</strong>
              </td>

              <td>{inputs.host}</td>
            </tr>

            <tr>
              <td>
                <strong>Port</strong>
              </td>

              <td>{inputs.port}</td>
            </tr>

            <tr>
              <td>
                <strong>Username</strong>
              </td>

              <td>{inputs.username}</td>
            </tr>

            <tr>
              <td>
                <strong>From Email</strong>
              </td>

              <td>{inputs.from}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <Modal
        visible={open}
        width="50%"
        height="70%"
        effect="fadeInUp"
        onClickAway={handleCloseModal}
      >
        <div
          style={{
            padding: 20,
            height: "100%",
            overflowY: "auto",
            position: "relative",
          }}
        >
          <button
            type="button"
            onClick={handleCloseModal}
            style={{
              position: "absolute",
              right: 15,
              top: 10,
              border: "none",
              background: "transparent",
              fontSize: 30,
              cursor: "pointer",
            }}
          >
            &times;
          </button>

          <h3 className="mb-4">
            {view ? "View SMTP Details" : "Edit SMTP Details"}
          </h3>

          {view ? (
            <table className="table table-bordered">
              <tbody>
                <tr>
                  <td>
                    <strong>Host</strong>
                  </td>

                  <td>{inputs.host}</td>
                </tr>

                <tr>
                  <td>
                    <strong>Port</strong>
                  </td>

                  <td>{inputs.port}</td>
                </tr>

                <tr>
                  <td>
                    <strong>Username</strong>
                  </td>

                  <td>{inputs.username}</td>
                </tr>

                <tr>
                  <td>
                    <strong>Password</strong>
                  </td>

                  <td>{inputs.password}</td>
                </tr>

                <tr>
                  <td>
                    <strong>From</strong>
                  </td>

                  <td>{inputs.from}</td>
                </tr>
              </tbody>
            </table>
          ) : (
            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label className="form-label">Host</label>

                <input
                  type="text"
                  className="form-control"
                  name="host"
                  value={inputs.host || ""}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div className="mb-3">
                <label className="form-label">Port</label>

                <input
                  type="text"
                  className="form-control"
                  name="port"
                  value={inputs.port || ""}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div className="mb-3">
                <label className="form-label">Username</label>

                <input
                  type="text"
                  className="form-control"
                  name="username"
                  value={inputs.username || ""}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div className="mb-3">
                <label className="form-label">Password</label>

                <input
                  type="password"
                  className="form-control"
                  name="password"
                  value={inputs.password || ""}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div className="mb-3">
                <label className="form-label">From Email</label>

                <input
                  type="email"
                  className="form-control"
                  name="from"
                  value={inputs.from || ""}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div className="d-flex justify-content-end">
                <button type="submit" className="btn btn-success">
                  Update
                </button>
                &nbsp;
                <button
                  type="button"
                  className="btn btn-warning"
                  onClick={handleCloseModal}
                >
                  Close
                </button>
              </div>
            </form>
          )}
        </div>
      </Modal>
    </div>
  );
};

export default Smtp;
